var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-section"},[(_vm.title)?_c('div',{staticClass:"app-section-container"},[_c('h2',{staticClass:"app-section-title",style:(_vm.titleStyle)},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('div',{staticClass:"app-section-content",style:(_vm.contentStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6047c6a0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/AppSection.vue
// module id = null
// module chunks = 